import { themedUseStyletron } from '../../../theme/customTheme'
import { IDriveThreeSpeed } from './types'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import {  StatefulOperationMode3Step } from '../Aggregate';
import { DriveIcon, DriveIconSimple } from '../DriveBase/DriveIcon';
import { Aggregate3StateText } from './Aggregate3StateText';

export function OverviewPanel(props: IDriveThreeSpeed) {
    const [, theme] = themedUseStyletron();


    return (
        <OverviewPanelWrapper {...props} icon={<DriveIconSimple schema={props.schema} color={theme.colors.backgroundPrimary} size='100%' />}>
            <DriveIcon isOn={props.isOn} schema={props.schema} color={props.isOn ? theme.appColors.aggregate.on : theme.appColors.aggregate.off} size='40px' />
            <Aggregate3StateText {...props}></Aggregate3StateText>
            <StatefulOperationMode3Step {...props} isCompact></StatefulOperationMode3Step>
        </OverviewPanelWrapper >
    );
}